export default "__VITE_ASSET__BFCkLHaj__"